import { Link } from 'react-router-dom';

const services = [
  { label: 'Interior Painting', href: '/services/interior-painting' },
  { label: 'Exterior Painting', href: '/services/exterior-painting' },
  { label: 'Cabinet Painting', href: '/services/cabinet-painting' },
  { label: 'Commercial Painting', href: '/services/commercial-painting' },
  { label: 'New Construction', href: '/services/new-construction' },
];

const areas = [
  'Elk Grove Village', 'Wood Dale', 'Des Plaines',
  'Arlington Heights', 'Schaumburg', 'Mount Prospect',
];

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-5">
              <img
                src="https://storage.readdy-site.link/project_files/43399b4d-8768-47cb-9d95-8b96544cbfdf/4188435a-902a-4aaa-b9f5-c2ecb57cd5b3_prev_logo-300x67.png?v=0729ceb822395e8d71573e396bb5d448"
                alt="Hometown Painters"
                className="h-9 w-auto object-contain"
                style={{ maxWidth: '160px' }}
              />
            </div>
            <p className="font-sans text-gray-500 text-sm leading-relaxed mb-5">
              Premier painting services for Elk Grove Village homes and businesses. Elevated finishes, every time.
            </p>
            <div className="flex flex-col gap-2">
              <a
                href="tel:8478701600"
                className="flex items-center gap-2 text-gray-800 font-sans text-sm font-medium hover:text-gray-500 transition-colors duration-200 cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill" style={{ fontSize: '14px', color: '#b8963e' }} />
                </div>
                (847) 870-1600
              </a>
              <a
                href="mailto:sales@hometownpainters.com"
                className="flex items-center gap-2 text-gray-500 font-sans text-sm hover:text-gray-800 transition-colors duration-200 cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line" style={{ fontSize: '14px', color: '#b8963e' }} />
                </div>
                sales@hometownpainters.com
              </a>
              <div className="flex items-center gap-2 text-gray-500 font-sans text-sm">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line" style={{ fontSize: '14px', color: '#b8963e' }} />
                </div>
                Elk Grove Village, IL
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-serif text-gray-900 text-base mb-5 tracking-wide">Services</h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.label}>
                  <Link
                    to={s.href}
                    className="font-sans text-gray-500 text-sm hover:text-gray-900 transition-colors duration-200 cursor-pointer"
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas */}
          <div>
            <h4 className="font-serif text-gray-900 text-base mb-5 tracking-wide">Service Areas</h4>
            <ul className="space-y-3">
              {areas.map((area) => (
                <li key={area}>
                  <span className="font-sans text-gray-500 text-sm flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full inline-block" style={{ backgroundColor: '#b8963e' }} />
                    {area}
                  </span>
                </li>
              ))}
              <li>
                <span className="font-sans text-gray-400 text-sm flex items-center gap-2">
                  <span className="w-1 h-1 bg-gray-300 rounded-full inline-block" />
                  + 9 More Communities
                </span>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-serif text-gray-900 text-base mb-5 tracking-wide">Get Started</h4>
            <p className="font-sans text-gray-500 text-sm leading-relaxed mb-5">
              Ready to transform your space? Request a free consultation today.
            </p>
            <a
              href="#quote"
              className="inline-block bg-gray-900 text-white font-sans font-medium text-sm px-6 py-3 rounded-full hover:bg-gray-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Request a Quote
            </a>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-sans text-gray-400 text-xs">
            © 2026 Hometown Painters. All rights reserved. Serving Elk Grove Village &amp; Chicago Suburbs.
          </p>
          <p className="font-sans text-gray-400 text-xs">
            Professional Interior &amp; Exterior Painting · Elk Grove Village, IL
          </p>
        </div>
      </div>
    </footer>
  );
}
